import { useLocation, useNavigate, useParams } from "react-router-dom";
import type { NavigateFunction, Location, Params } from "react-router-dom";

export interface RouterProps {
  navigate: NavigateFunction;
  location: Location;
  params: Readonly<Params<string>>;
}

export interface ReactRouterClassWrapperProps {
  children: (routerProps: RouterProps) => React.ReactNode;
}

export default function ReactRouterClassWrapper({ children }: ReactRouterClassWrapperProps) {
  const routerProps = {
    navigate: useNavigate(),
    location: useLocation(),
    params: useParams(),
  };

  return children(routerProps);
}
